import * as Sentry from "@sentry/react";

import { Config, getEnvironmentType } from "@/lib/config";

export interface SentryUser {
  email: string;
  tenant: string;
}

export const setSentryUser = (user: SentryUser) => {
  Sentry.setUser({
    email: user.email,
    tenant: user.tenant,
  });
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

export const addSentryBreadcrumb = (
  message: string,
  category?: string,
  level?: Sentry.SeverityLevel,
  data?: Record<string, unknown>,
) => {
  Sentry.addBreadcrumb({
    message,
    category: category,
    level: level || "info",
    data,
    timestamp: Date.now() / 1000,
  });
};

const getSamplingRates = (environment: string) => {
  switch (environment) {
    case "production":
      return {
        tracesSampleRate: 0.05,
        replaysOnErrorSampleRate: 0.25,
        replaysSessionSampleRate: 0.01,
      };
    case "staging":
      return {
        tracesSampleRate: 0.1,
        replaysOnErrorSampleRate: 0.9,
        replaysSessionSampleRate: 0.2,
      };
    case "development":
      return {
        tracesSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        replaysSessionSampleRate: 0,
      };
    default:
      throw new Error(`Unknown environment: ${environment}`);
  }
};

try {
  const environment = getEnvironmentType() || "development";
  const tenant = Config.tenant;

  if (environment === "development") {
    console.log("Sentry disabled in development environment");
  } else {
    Sentry.init({
      dsn: "https://2fca96990efd3a2b991dc2b18ae980bd@o45140.ingest.us.sentry.io/4509830206652416",
      debug: false,
      ...getSamplingRates(environment),
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      environment: environment,
    });

    if (tenant) {
      Sentry.setTag("tenant", tenant);
    }
  }
} catch (error) {
  console.error("Failed to initialize Sentry:", error);
}
